import * as React from 'react';

import { PageTitleBar } from 'components';

const DiscountCodeHeader = ({ children }: React.PropsWithChildren<unknown>) => (
  <PageTitleBar headerTitle={children} />
);

export { DiscountCodeHeader };
